export enum enumTranslateRolesInRoutes {
  'Estudante' = 'candidate',
  'Administrador da Empresa' = 'company',
  'Administrador de Instituição' = 'institution/admin',
  'Administrador de Campus' = 'institution/campusadmin',
  'Administrador Contratanet' = 'admin',
  'Orientador' = 'institution/advisor',
}
